import React from 'react';
import { Modal } from 'antd';
import { ModalFuncProps } from 'antd/lib/modal';
import {
  modalGlobalConfig,
  ModalFunc as ModalFuncType,
} from 'antd/lib/modal/confirm';

export type { modalGlobalConfig, ModalFuncProps, ModalFuncType };

export default Modal;
